<!-- eslint-disable camelcase -->
<template>
  <div>
    <div class="query_head">
      <span class="query_pond">数据导出</span>
    </div>
    <div class="query_change" style="font-size: 12px">
      <div class="margin_cell">
        <div class="cell_style">选择终端：</div>
        <div class="margin_parmas">
          <el-select v-model="checkedTerm" placeholder="请选择终端" style="border:1px solid #dcdfe6; width: 300px">
            <el-option
              v-for="term in listTerm"
              :key="term.id"
              :label="term.name"
              :value="term.id">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="margin_cell">
        <div class="cell_style">选择环境参数：</div>
        <div class="margin_parmas">
          <el-checkbox-group v-model="checkedparams" @change="handleCheckedParamsChange">
            <el-checkbox class="margin-bom" v-for="params in cell_params_list" :label="params.typeCHN" :key="params.snpid">{{params.typeCHN}}</el-checkbox>
          </el-checkbox-group></div>
      </div>
      <div  class="margin_cell margin_button">
        <div class="cell_style">时间范围选择：</div>
        <el-date-picker
          class="date_pick"
          v-model="his_time"
          type="datetimerange"
          :picker-options="pickerOptions"
          align="right"
          value-format="yyyy-MM-dd HH:mm:ss"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :default-time="['12:00:00', '08:00:00']">
        </el-date-picker>
        <el-button class="margin_left" type="primary" @click="downData()">导出</el-button>
      </div>
    </div>
    <div class="hisQurey" ref="hisQurey" :style="{width: curWidth, height:'500px'}"></div>
  </div>
</template>

<script>
// import blob from '../../excel/Blob.js'
// import Export2Excel from '../../excel/Export2Excel.js'
export default {
  data () {
    return {
      checkedCell: [],
      checkedparams: [],
      cell_params_all: [],
      cell_params_list: [],
      token: window.sessionStorage.getItem('token'),
      username: window.sessionStorage.getItem('username'),
      listCell: [],
      listTerm: [],
      his_time: [],
      checkedTerm: '',
      pickerOptions: {
        shortcuts: [{
          text: '最近一天',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近半年',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      curWidth: ''
    }
  },
  methods: {
    handleCheckedCellChange (value) {
      // console.log(value)
    },
    handleCheckedParamsChange (value) {
      // console.log(value)
    },
    getAllTerm () {
      this.axios.get(this.$store.state.ip + 'termdef/listTermsByUsr',
        {
          params: {'user_name': this.username},
          headers: {'Authorization': 'Bearer ' + this.token}
        }).then(res => {
        this.listTerm = res.data.data.list
      }).catch(err => {
        console.log(err)
      })
    },
    getAllCell () {
      this.cell_params_all = []
      this.cell_params_list = []
      this.axios.get(this.$store.state.ip + 'celldef/listUserCells',
        {
          params: {'username': this.username},
          headers: {'Authorization': 'Bearer ' + this.token}
        }).then(res => {
        this.listCell = (res.data.data.list)
        for (let i = 0; i < this.listCell.length; i++) {
          this.axios.get(this.$store.state.ip + 'sensordef/cellParams',
            {
              params: {'cell_id': this.listCell[i].id},
              headers: {'Authorization': 'Bearer ' + this.token}
            }).then(res => {
            let k
            for (let j = 0; j < res.data.data.length; j++) {
              this.cell_params_all.push(res.data.data[j])
              for (k = 0; k < this.cell_params_list.length; k++) {
                if (res.data.data[j].typeCHN === this.cell_params_list[k].typeCHN) {
                  break
                }
              }
              if (this.cell_params_list.length === k) {
                this.cell_params_list.push(res.data.data[j])
              }
            }
          }).catch(err => {
            console.log(err)
          })
        }
      }).catch(err => {
        console.log(err)
      })
    },
    downData () {
      let test = []
      for (let j = 0; j < this.checkedparams.length; j++) {
        for (let i = 0; i < this.cell_params_all.length; i++) {
          if (this.cell_params_all[i].typeCHN === this.checkedparams[j]) {
            test.push(this.cell_params_all[i].type)
            break
          }
        }
      }
      // let test1 = ''
      // test1 = test.join(',')
      // console.log(test1)
      console.log(test)
      for (let i = 0; i < test.length; i++) {
        this.axios.get(this.$store.state.ip + 'opt/exportTermParam',
          {
            params: {'term_id': this.checkedTerm, 'snp_types': test[i], 'start_time': this.his_time[0], 'end_time': this.his_time[1]},
            headers: {'Authorization': 'Bearer ' + this.token}
          }).then(res => {
          let tt = res.data.data
          console.log(tt)
          let tableData = []
          let testData = Object.keys(res.data.data)
          let testtype = test[i]
          for (let j = 0; j < testData.length; j++) {
            tableData.push({index: j + 1, value: tt[testData[j]][testtype], time: testData[j]})
          }
          require.ensure([], () => {
            // eslint-disable-next-line camelcase
            const { export_json_to_excel } = require('../../excel/Export2Excel')
            const tHeader = ['序号', '值', '时间']
            const filterVal = ['index', 'value', 'time']
            const list = tableData
            const data = this.formatJson(filterVal, list)
            export_json_to_excel(tHeader, data, test[i] + '列表')
          })
        }).catch(err => {
          console.log(err)
        })
      }
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => {
        return filterVal.map(j => v[j])
      })
    },
    // 时间戳转换为标准时间
    resetTime (time) {
      let test = new Date(time * 1000)
      let year = test.getFullYear() // 取得4位数的年份
      let month = ('0' + (test.getMonth() + 1)).slice(-2) // 取得日期中的月份，其中0表示1月，11表示12月
      let date = ('0' + test.getDate()).slice(-2) // 返回日期月份中的天数（1到31）
      let hour = ('0' + test.getHours()).slice(-2) // 返回日期中的小时数（0到23）
      let minute = ('0' + test.getMinutes()).slice(-2) // 返回日期中的分钟数（0到59）
      let second = ('0' + test.getSeconds()).slice(-2) // 返回日期中的秒数（0到59）
      return year + '-' + month + '-' + date + ' ' + hour + ':' + minute + ':' + second
    }
  },
  created () {
    this.getAllTerm()
    this.getAllCell()
    this.curWidth = document.body.clientWidth - 260 + 'px'
  }
}
</script>

<style scoped>
  .margin_cell {
    display: flex;
    align-items: left;
    justify-content: left;
    padding-top: 8px;
    padding-left: 10px;
  }
  .margin_parmas {
    display: flex;
    float: left;
    width: 88%;
    text-align: left;
  }
  .cell_style{
    font-size: 14px;
    font-weight: bold;
    width: 120px;
  }
  .margin-bom {
    margin-bottom: 10px;
  }
  .margin_button {
    display: flex;
    align-items: center;
    justify-content: left;
    padding-top: 8px;
    padding-left: 10px;
  }
  .date_pick {
    border: 1px solid #DCDFE6;
    border-radius: 4px;
  }
  .margin_left {
    margin-left: 20px;
  }
  .query_change {
    margin-top: 20px;
    margin-bottom: 20px;
    background-color: white;
    min-height: 110px;
    padding-bottom: 10px;
  }
  .hisQurey{
    margin: 0 auto;
    margin-top: 30px;
    padding-top: 20px;
    padding-bottom: 15px;
    padding-left: 10px;
    padding-right: 10px;
    background-color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/userData/downLoad.vue